import React from 'react'
import { Link } from 'react-router-dom'
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import Footer from '../../components/Footer/Footer';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
function Services() {
  return (
    <>
      <div id='services' className='py-40 bg-[#3C31A2]'>
        <h2 data-aos="zoom-in" className='text-white leading-[50px] sm:leading-normal font-bold text-[50px] text-center'>Тарифы и услуги</h2>
      </div>
      <div>
        <div className='py-6  bg-[#2F2C3D]'>
          <div className='sm:container px-5 mx-auto flex items-center space-x-1 text-white'>
            <Link className='border-b-2  border-white' to={'/'}>Главный</Link>
            <DoubleArrowIcon style={{ "inlineSize": "20px", "blockSize": "20px" }} />
            <span>Тарифы и услуги</span>
          </div>
        </div>
        <div className='bg-[#262431] py-10'>
          <div className='container mx-auto px-5'>
            <div data-aos="zoom-in-up" className='sm:px-20'>
              <h3 className='font-bold mb-2 text-white text-[22px] sm:text-[28px]'>Онлайн касса Cashbox: Модели и цены</h3>
              <ul className='text-white space-y-3 text-[13px] mb-5 sm:text-[14px]'>
                <li>МОДЕЛЬ: CASHBOX типа POS Terminal T1</li>
                <li>ЦЕНА: 2 800 000,0 сум *</li>
                <li>* - цена указано за 1 онлайн ККМ аппарат в т.ч. НДС 6%</li>
              </ul>
            </div>
            <div data-aos="zoom-in-up" className='sm:px-20 mt-7 sm:mt-10'>
              <h3 className='font-bold mb-2 text-white text-[22px] sm:text-[28px]'>Абонентская плата</h3>
              <p className='text-white text-[13px] sm:text-[15px]'>Абонентская плата – 77 000 сум в месяц за одну онлайн ККМ в т.ч. НДС 6%</p>
              <div className='mt-5'>
                <h4 className='text-white text-[13px] sm:text-[15px]'>В стоимость входит:</h4>
                <div className='mt-5 flex flex-col md:flex-row justify-center md:space-x-40'>
                  <div data-aos="zoom-in-up" className='sm:w-[425px]'>
                    <div className='flex mb-2 items-center space-x-2 text-white'>
                      <FiberManualRecordIcon className='text-[#00C9DB]' style={{ "inlineSize": "15px", "blockSize": "15px" }} />
                      <span>Обучение работе с онлайн ККМ пользователя</span>
                    </div>
                    <div className='flex mb-2 items-center space-x-2 text-white'>
                      <FiberManualRecordIcon className='text-[#00C9DB]' style={{ "inlineSize": "15px", "blockSize": "15px" }} />
                      <span>Подготовка онлайн ККМ к работе, первый пуск</span>
                    </div>
                    <div className='flex mb-2 items-center space-x-2 text-white'>
                      <FiberManualRecordIcon className='text-[#00C9DB]' style={{ "inlineSize": "15px", "blockSize": "15px" }} />
                      <span>Индивидуальные настройки онлайн ККМ – настройка аппаратного и программное обеспечение под каждого клиента</span>
                    </div>
                    <div className='flex mb-2 items-center space-x-2 text-white'>
                      <FiberManualRecordIcon className='text-[#00C9DB]' style={{ "inlineSize": "15px", "blockSize": "15px" }} />
                      <span>Техническая поддержка 365 дней в году</span>
                    </div>
                    <div className='flex mb-2 items-center space-x-2 text-white'>
                      <FiberManualRecordIcon className='text-[#00C9DB]' style={{ "inlineSize": "15px", "blockSize": "15px" }} />
                      <span>Консультации и обучение в области работы с кассовыми машинами и сопутствующим оборудованием</span>
                    </div>
                    <div className='flex mb-2 items-center space-x-2 text-white'>
                      <FiberManualRecordIcon className='text-[#00C9DB]' style={{ "inlineSize": "15px", "blockSize": "15px" }} />
                      <span>Оказание технической поддержки работы устройства, обслуживание работы кассовых систем, оказание сервисных услуг</span>
                    </div>
                    <div className='flex mb-2 items-center space-x-2 text-white'>
                      <FiberManualRecordIcon className='text-[#00C9DB]' style={{ "inlineSize": "15px", "blockSize": "15px" }} />
                      <span>Оказание платного и бесплатного ремонта устройства</span>
                    </div>
                    <div className='flex mb-2 items-center space-x-2 text-white'>
                      <FiberManualRecordIcon className='text-[#00C9DB]' style={{ "inlineSize": "15px", "blockSize": "15px" }} />
                      <span>Установка обновлений на онлайн ККМ (в офисах компании)</span>
                    </div>
                  </div>
                  <div data-aos="zoom-in-up" className='sm:w-[425px]'>
                    <div className='flex mb-2 items-center space-x-2 text-white'>
                      <FiberManualRecordIcon className='text-[#00C9DB]' style={{ "inlineSize": "15px", "blockSize": "15px" }} />
                      <span>Бесплатное предоставление интернета для передачи неотправленных чеков и обновления программного обеспечения онлайн ККМ (только в офисах компании)</span>
                    </div>
                    <div className='flex mb-2 items-center space-x-2 text-white'>
                      <FiberManualRecordIcon className='text-[#00C9DB]' style={{ "inlineSize": "15px", "blockSize": "15px" }} />
                      <span>Бесплатное предоставление обменной онлайн ККМ временно! (в случае, если онлайн ККМ находится в ремонте)</span>
                    </div>
                    <div className='flex mb-2 items-center space-x-2 text-white'>
                      <FiberManualRecordIcon className='text-[#00C9DB]' style={{ "inlineSize": "15px", "blockSize": "15px" }} />
                      <span>Предоставление качественных услуг в точно установленные сроки, предусмотренные договором</span>
                    </div>
                    <div className='flex mb-2 items-center space-x-2 text-white'>
                      <FiberManualRecordIcon className='text-[#00C9DB]' style={{ "inlineSize": "15px", "blockSize": "15px" }} />
                      <span>Проверка соответствия кассового оборудования стандартам и нормативно-правовой базе</span>
                    </div>
                    <div className='flex mb-2 items-center space-x-2 text-white'>
                      <FiberManualRecordIcon className='text-[#00C9DB]' style={{ "inlineSize": "15px", "blockSize": "15px" }} />
                      <span>Бесплатное ежегодная диагностика работы онлайн ККМ</span>
                    </div>
                    <div className='flex mb-2 items-center space-x-2 text-white'>
                      <FiberManualRecordIcon className='text-[#00C9DB]' style={{ "inlineSize": "15px", "blockSize": "15px" }} />
                      <span>Рекомендация по приобретению ККМ и расходных материалов (АКБ, бумага итд.)</span>
                    </div>

                  </div>
                </div>
              </div>
              <div className='mt-10'>
                <h3 className='font-bold mb-5 text-white text-[22px] sm:text-[28px]'>Ремонт и техническое обслуживание</h3>
                <table className='mx-auto'>
                  <thead>
                    <tr>
                      <th className='p-5 border-[1px] text-white border-white text-center w-[770px]'>Техническое обслуживание</th>
                      <th className='p-5 border-[1px] text-white border-white text-center w-[180px]'>	Цена</th>
                    </tr>
                  </thead>
                  <tbody className='text-[15px]'>
                    <tr>
                      <td data-aos="zoom-in-up" className='p-3 border-[1px] text-white border-white '>Диагностика технического состояния работы онлайн ККМ</td>
                      <td data-aos="zoom-in-up" className='p-3 border-[1px] text-white border-white '>БЕСПЛАТНО</td>
                    </tr>
                    <tr>
                      <td data-aos="zoom-in-up" className='p-3 border-[1px] text-white border-white '>Ежегодное техническое освидетельствование онлайн ККМ</td>
                      <td data-aos="zoom-in-up" className='p-3 border-[1px] text-white border-white '>БЕСПЛАТНО</td>
                    </tr>
                    <tr>
                      <td data-aos="zoom-in-up" className='p-3 border-[1px] text-white border-white '>Человеко час стоимость работ рассчитывается исходя из потраченного времени специалистом на ремонт</td>
                      <td data-aos="zoom-in-up" className='p-3 border-[1px] text-white border-white '>60 000.00 сум</td>
                    </tr>
                    <tr>
                      <td data-aos="zoom-in-up" className='p-3 border-[1px] text-white border-white '>Премиум обучение по работе онлайн ККМ</td>
                      <td data-aos="zoom-in-up" className='p-3 border-[1px] text-white border-white '>	130 000.00 сум за 1 час</td>
                    </tr>
                    <tr>
                      <td data-aos="zoom-in-up" className='p-3 border-[1px] text-white border-white '>Выезд специалиста по месту расположения клиента (в черте города)</td>
                      <td data-aos="zoom-in-up" className='p-3 border-[1px] text-white border-white '>73 000 сум</td>
                    </tr>
                    <tr>
                      <td data-aos="zoom-in-up" className='p-3 border-[1px] text-white border-white '>Выезд специалиста по месту расположения клиента за чертой города</td>
                      <td data-aos="zoom-in-up" className='p-3 border-[1px] text-white border-white '>6 000 сум/км за 1 км</td>
                    </tr>
                    <tr>
                      <td data-aos="zoom-in-up" className='p-3 border-[1px] text-white border-white '>Восстановления работы устройства (сертификата безопасности) из-за несанкционированного вскрытия устройства пользователем</td>
                      <td data-aos="zoom-in-up" className='p-3 border-[1px] text-white border-white '>665 000 сум</td>
                    </tr>
                    <tr>
                      <td data-aos="zoom-in-up" className='p-3 border-[1px] text-white border-white '>Ремонт с заменой термопечатающей головки</td>
                      <td data-aos="zoom-in-up" className='p-3 border-[1px] text-white border-white '>200 000 сум</td>
                    </tr>
                    <tr>
                      <td data-aos="zoom-in-up" className='p-3 border-[1px] text-white border-white '>Ремонт с заменой дисплея</td>
                      <td data-aos="zoom-in-up" className='p-3 border-[1px] text-white border-white '>500 000 сум</td>
                    </tr>
                    <tr>
                      <td data-aos="zoom-in-up" className='p-3 border-[1px] text-white border-white '>Ремонт с заменой аккумулятора</td>
                      <td data-aos="zoom-in-up" className='p-3 border-[1px] text-white border-white '>215 000 сум</td>
                    </tr>
                    <tr>
                      <td data-aos="zoom-in-up" className='p-3 border-[1px] text-white border-white '>Ремонт с заменой корпуса (полностью)</td>
                      <td data-aos="zoom-in-up" className='p-3 border-[1px] text-white border-white '>434 000 сум</td>
                    </tr>
                    <tr>
                      <td data-aos="zoom-in-up" className='p-3 border-[1px] text-white border-white '>Ремонт с заменой крышки от лотка термобумаги</td>
                      <td data-aos="zoom-in-up" className='p-3 border-[1px] text-white border-white '>42 000 сум</td>
                    </tr>
                    <tr>
                      <td data-aos="zoom-in-up" className='p-3 border-[1px] text-white border-white '>Ремонт с заменой крышки аккумуляторного отсека</td>
                      <td data-aos="zoom-in-up" className='p-3 border-[1px] text-white border-white '>42 000 сум</td>
                    </tr>
                    <tr>
                      <td data-aos="zoom-in-up" className='p-3 border-[1px] text-white border-white '>Refurbished – восстановление до заводского состояния (без замены материнской платы)</td>
                      <td data-aos="zoom-in-up" className='p-3 border-[1px] text-white border-white '>2 730 000 сум</td>
                    </tr>
                    <tr>
                      <td data-aos="zoom-in-up" className='p-3 border-[1px] text-white border-white '>Ремонт с заменой материнской платы</td>
                      <td data-aos="zoom-in-up" className='p-3 border-[1px] text-white border-white '>2 680 000 сум</td>
                    </tr>
                    <tr>
                      <td data-aos="zoom-in-up" className='p-3 border-[1px] text-white border-white '>Ремонт с заменой кнопок питания, регулировки громкости</td>
                      <td data-aos="zoom-in-up" className='p-3 border-[1px] text-white border-white '>232 000 сум</td>
                    </tr>
                    <tr>
                      <td data-aos="zoom-in-up" className='p-3 border-[1px] text-white border-white '>Ремонт с заменой динамика</td>
                      <td data-aos="zoom-in-up" className='p-3 border-[1px] text-white border-white '>117 000 сум</td>
                    </tr>
                    <tr>
                      <td data-aos="zoom-in-up" className='p-3 border-[1px] text-white border-white '>Ремонт с заменой основной камеры</td>
                      <td data-aos="zoom-in-up" className='p-3 border-[1px] text-white border-white '>448 000.00 сум</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <a href={'#services'} className='w-[42px] rotate-90 duration-200 fixed right-5 bottom-5 h-[42px] text-white flex items-center justify-center rounded-[50%] bg-[#00C9DB] hover:bg-[#73e5f0]'>
          <ArrowBackIosNewIcon />
        </a>
      </div>
      <Footer bg={true} />
    </>
  )
}

export default Services